module.exports = __webpack_public_path__ + "static/MC_tarjeta_credito_debito-014ce2c3b9232b5c769e17b663442d3d.svg";